import React, { Component } from 'react';

import OwlCarousel from 'react-owl-carousel';

class Slider extends Component {
    shouldComponentUpdate() {
        return false
    }
    render() {
        return (
            <OwlCarousel
                className="owl-theme"
                startPosition={0}
                margin={20}
                loop
                nav
                onChanged={this.props._onChanged}
                onChange={this.props._onChange}
                navText={["", ""]}
                navContainerClass="controller"
                navClass={["arrow right", "arrow left"]}
                dots={false}
                responsiveClass={true}
                responsive={{
                    0: {
                        items: 2,
                        slideBy: 2,
                        autoWidth: true,
                        rtl: true
                    },
                    490: {
                        items: 2,
                        center: true,
                        autoWidth: true,
                        rtl: true
                    },
                    1024: {
                        items: 2
                    }
                }}
            >
                {this.props.getItems}
            </OwlCarousel>
        );
    }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/Components/App/Slider.js